import * as actionType from "./constants";

const initialState = {
    getSurveyorDataResponse: {},
    getSurveyorDataLoadingResponse: false,
    getSurveyorProjectDataResponse: {},
    getSurveyorProjectDataLoadingResponse: false,
    getSurveyorAppInfoDataResponse: {},
    getSurveyorAppInfoDataLoadingResponse: false,
    getSurveyorByIdResponse: {},
    getSurveyorByIdLoadingResponse: false,
    getListForCommonFilterResponse: {},
    getListForCommonSurveyorFilterResponse: {},
    getListForCommonFilterLoadingResponse: false,
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    appInfoEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    fcaAppInfoEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    projectEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    fcaProjectEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    getSurveyorProjectByIdLoadingResponse: false,
    getSurveyorProjectByIdResponse: null,
    getSurveyorProjectHistoryDataLoadingResponse: false,
    getSurveyorProjectHistoryDataResponse: null,
    getListForProjectHistoryCommonFilterResponse: null,
    getListForProjectHistoryCommonFilterLoadingResponse: false,
    getSurveyorProjectHistoryByIdResponse: null,
    historyEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    fcaHistoryEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    },
    getSurveyorTableExport: {},
    getSurveyorProfileCommonFilterResponse: {},
    getSurveyorProfileCommonFilterLoading: false,
    getSurveyorAppCommonFilterResponse: {},
    getSurveyorAppCommonFilterLoading: false,
    getSurveyorAppInfoTableExport: {},
    getSurveyorProjectTableExport: {}
};

const buildResponse = (key, success, data) => ({
    [key]: { success, ...data }
});

const setLoading = (key, value) => ({
    [key]: value
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionType.GET_LIST_FOR_COMMON_FILTER_REQUEST:
            return { ...state, ...setLoading("getListForCommonFilterLoadingResponse", true) };
        case actionType.GET_LIST_FOR_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                ...setLoading("getListForCommonFilterLoadingResponse", false),
                getListForCommonFilterResponse: { success: true, list: action.response || [] }
            };
        case actionType.GET_LIST_FOR_COMMON_FILTER_FAILURE:
            return {
                ...state,
                ...setLoading("getListForCommonFilterLoadingResponse", false),
                getListForCommonFilterResponse: { success: false, list: [] }
            };

        case actionType.GET_SURVEYOR_DATA_REQUEST:
            return { ...state, ...setLoading("getSurveyorDataLoadingResponse", true) };
        case actionType.GET_SURVEYOR_DATA_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorDataResponse", true, action.response),
                ...setLoading("getSurveyorDataLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_DATA_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorDataResponse", false, action.error),
                ...setLoading("getSurveyorDataLoadingResponse", false)
            };

        case actionType.GET_SURVEYOR_APP_INFO_DATA_REQUEST:
            return { ...state, ...setLoading("getSurveyorAppInfoDataLoadingResponse", true) };
        case actionType.GET_SURVEYOR_APP_INFO_DATA_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorAppInfoDataResponse", true, action.response),
                ...setLoading("getSurveyorAppInfoDataLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_APP_INFO_DATA_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorAppInfoDataResponse", false, action.error),
                ...setLoading("getSurveyorAppInfoDataLoadingResponse", false)
            };

        case actionType.GET_SURVEYOR_PROJECT_DATA_REQUEST:
            return { ...state, ...setLoading("getSurveyorProjectDataLoadingResponse", true) };
        case actionType.GET_SURVEYOR_PROJECT_DATA_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectDataResponse", true, action.response),
                ...setLoading("getSurveyorProjectDataLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_PROJECT_DATA_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectDataResponse", false, action.error),
                ...setLoading("getSurveyorProjectDataLoadingResponse", false)
            };

        case actionType.GET_SURVEYOR_BY_ID_REQUEST:
            return { ...state, ...setLoading("getSurveyorByIdLoadingResponse", true) };
        case actionType.GET_SURVEYOR_BY_ID_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorByIdResponse", true, action.response),
                ...setLoading("getSurveyorByIdLoadingResponse", true)
            };
        case actionType.GET_SURVEYOR_BY_ID_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorByIdResponse", false, action.error),
                ...setLoading("getSurveyorByIdLoadingResponse", true)
            };

        case actionType.UPDATE_SURVEYOR_ENTITY_PARAMS_SUCCESS:
            const entity =
                action?.entity === "app"
                    ? "appInfoEntityParams"
                    : action?.entity === "fca-app"
                    ? "fcaAppInfoEntityParams"
                    : action?.entity === "project"
                    ? "projectEntityParams"
                    : action?.entity === "fca-project"
                    ? "fcaProjectEntityParams"
                    : "entityParams";
            return {
                ...state,
                ...buildResponse(entity, true, action.response)
            };

        case actionType.UPDATE_SURVEYOR_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                ...buildResponse("entityParams", false, state?.entityParams)
            };

        case actionType.GET_SURVEYOR_PROJECT_BY_ID_REQUEST:
            return { ...state, ...setLoading("getSurveyorProjectByIdLoadingResponse", true) };
        case actionType.GET_SURVEYOR_PROJECT_BY_ID_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectByIdResponse", true, action.response),
                ...setLoading("getSurveyorProjectByIdLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_PROJECT_BY_ID_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectByIdResponse", false, action.error),
                ...setLoading("getSurveyorProjectByIdLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_PROJECT_HISTORY_DATA_REQUEST:
            return { ...state, ...setLoading("getSurveyorProjectHistoryDataLoadingResponse", true) };
        case actionType.GET_SURVEYOR_PROJECT_HISTORY_DATA_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectHistoryDataResponse", true, action.response),
                ...setLoading("getSurveyorProjectHistoryDataLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_PROJECT_HISTORY_DATA_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectHistoryDataResponse", false, action.error),
                ...setLoading("getSurveyorProjectHistoryDataLoadingResponse", false)
            };
        case actionType.UPDATE_SURVEYOR_HISTORY_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                ...buildResponse(action?.entity === "FCA" ? "fcaHistoryEntityParams" : "historyEntityParams", true, action.response)
            };

        case actionType.UPDATE_SURVEYOR_HISTORY_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                ...buildResponse(action?.entity === "FCA" ? "fcaHistoryEntityParams" : "historyEntityParams", false, state?.entityParams)
            };
        case actionType.GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_REQUEST:
            return { ...state, ...setLoading("getListForProjectHistoryCommonFilterLoadingResponse", true) };

        case actionType.GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                ...setLoading("getListForProjectHistoryCommonFilterLoadingResponse", false),
                getListForProjectHistoryCommonFilterResponse: { success: true, list: action.response || [] }
            };
        case actionType.GET_LIST_FOR_PROJECT_HISTORY_COMMON_FILTER_FAILURE:
            return {
                ...state,
                ...setLoading("getListForProjectHistoryCommonFilterLoadingResponse", false),
                getListForProjectHistoryCommonFilterResponse: { success: false, list: [] }
            };
        case actionType.GET_SURVEYOR_PROJECT_HISTORY_BY_ID_REQUEST:
            return { ...state, ...setLoading("getSurveyorProjectByIdLoadingResponse", true) };
        case actionType.GET_SURVEYOR_PROJECT_HISTORY_BY_ID_SUCCESS:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectHistoryByIdResponse", true, action.response),
                ...setLoading("getSurveyorProjectByIdLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_PROJECT_HISTORY_BY_ID_FAILURE:
            return {
                ...state,
                ...buildResponse("getSurveyorProjectHistoryByIdResponse", false, action.error),
                ...setLoading("getSurveyorProjectByIdLoadingResponse", false)
            };
        case actionType.GET_SURVEYOR_TABLE_EXPORT_REQUEST:
            return {
                ...state,
                getSurveyorTableExport: { loading: true }
            };
        case actionType.GET_SURVEYOR_TABLE_EXPORT_SUCCESS:
            return {
                ...state,
                getSurveyorTableExport: { loading: false, success: true, data: { ...action.response } }
            };
        case actionType.GET_SURVEYOR_TABLE_EXPORT_FAILURE:
            return {
                ...state,
                getSurveyorTableExport: { loading: false, success: false, ...action.error }
            };
        case actionType.RESET_GET_REDUCER:
            return {
                ...state,
                assetSurveyProjectsList: { loading: false }
            };
        case actionType.GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_REQUEST:
            return { ...state, ...setLoading("getSurveyorProfileCommonFilterLoading", true) };
        case actionType.GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                ...setLoading("getSurveyorProfileCommonFilterLoading", false),
                getSurveyorProfileCommonFilterResponse: { success: true, list: action.response || [], count: action.response.count }
            };
        case actionType.GET_LIST_FOR_SURVEYOR_PROFILE_COMMON_FILTER_FAILURE:
            return {
                ...state,
                ...setLoading("getSurveyorProfileCommonFilterLoading", false),
                getSurveyorProfileCommonFilterResponse: { success: false, list: [] }
            };
        case actionType.GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_REQUEST:
            return { ...state, ...setLoading("getSurveyorAPPCommonFilterLoading", true) };
        case actionType.GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_SUCCESS:
            return {
                ...state,
                getSurveyorAppCommonFilterResponse: { success: true, list: action.response || [], count: action.response.count },
                ...setLoading("getSurveyorAPPCommonFilterLoading", false)
            };
        case actionType.GET_LIST_FOR_SURVEYOR_APP_COMMON_FILTER_FAILURE:
            return {
                ...state,
                ...setLoading("getSurveyorAPPCommonFilterLoading", false),
                getSurveyorAppCommonFilterResponse: { success: false, list: [] }
            };
        case actionType.GET_SURVEYOR_APP_TABLE_EXPORT_REQUEST:
            return {
                ...state,
                getSurveyorAppInfoTableExport: { loading: true }
            };
        case actionType.GET_SURVEYOR_APP_TABLE_EXPORT_SUCCESS:
            return {
                ...state,
                getSurveyorAppInfoTableExport: { loading: false, success: true, data: { ...action.response } }
            };
        case actionType.GET_SURVEYOR_APP_TABLE_EXPORT_FAILURE:
            return {
                ...state,
                getSurveyorAppInfoTableExport: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_SURVEYOR_PROJECT_TABLE_EXPORT_REQUEST:
            return {
                ...state,
                getSurveyorProjectTableExport: { loading: true }
            };
        case actionType.GET_SURVEYOR_PROJECT_TABLE_EXPORT_SUCCESS:
            return {
                ...state,
                getSurveyorProjectTableExport: { loading: false, success: true, data: { ...action.response } }
            };
        case actionType.GET_SURVEYOR_PROJECT_TABLE_EXPORT_FAILURE:
            return {
                ...state,
                getSurveyorProjectTableExport: { loading: false, success: false, ...action.error }
            };

        default:
            return state;
    }
}
